import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../../environments/environment';


@Injectable({
	providedIn: 'root',
})
export class ApplicationInsightsService {
	private appInsights?: ApplicationInsights;
  
	initialize() {
	  try {
		this.appInsights = new ApplicationInsights({
		  config: {
		  connectionString: environment.appInsightsConnectionString,
		  enableAutoRouteTracking: true,
		  enableCorsCorrelation: true,
		  enableRequestHeaderTracking: true,
		  enableResponseHeaderTracking: true,
		  }
		});
	  this.appInsights.loadAppInsights();
	  this.appInsights.addTelemetryInitializer((envelope) => {
		if (envelope.tags) {
		  envelope.tags['ai.cloud.role'] = 'mifel-front';
		  envelope.tags['ai.cloud.roleInstance'] = 'web';
		}
	  });
  
	  this.appInsights.trackPageView();
	  console.log('✅ AppInsights initialized', this.appInsights);
	  } catch (e) {
		console.warn('AppInsights init failed', e);
	  }
	}
  
  
  
	trackEvent(name: string, properties?: { [key: string]: any }) {
	  this.appInsights?.trackEvent({ name }, properties);
	}
  
	trackException(error: Error) {
	  this.appInsights?.trackException({ exception: error });
	}
  
	trackPageView(name?: string) {
	  this.appInsights?.trackPageView({ name });
	}
  }
  